import { useContentLanguage } from '@k3/core'
import { Ruler, RulerInformation } from './Ruler'
import { useDimensions } from './useDimensions'
import { useOrderDialogOpenState } from '../../store/orderDialog/orderDialogHooks'

export function Rulers() {
  const { length, width, angle } = useDimensions()
  const orderDialogOpened = useOrderDialogOpenState()
  const mainColor = '#000'
  const language = useContentLanguage()
  const formatter = new Intl.NumberFormat(language, {
    style: 'unit',
    unit: 'millimeter',
    unitDisplay: 'short',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  const depth = length / Math.tan(Math.PI / 2 - angle)
  const height = length * Math.sin(Math.PI / 2 - angle)

  const horizontal: RulerInformation = {
    name: 'horizontal',
    startPoint: [-width / 2, 0, -0.2],
    endPoint: [width / 2, 0, -0.2],
    color: mainColor,
    thickness: 1,
    text: {
      size: 0.05,
      color: mainColor,
      position: orderDialogOpened ? [0, 0.0, -0.25] : [0, 0.02, -0.2],
      rotation: [Math.PI / 2, Math.PI, 0],
      sprite: !orderDialogOpened,
    },
    length: width,
    endLines: {
      direction: [0, 0, 1],
    },
    formatter: (x) => formatter.format(1000 * x),
  }

  const diagonal: RulerInformation = {
    name: 'diagonal',
    startPoint: [width / 2 + 0.15, 0, -0],
    endPoint: [width / 2 + 0.15, height, depth],
    color: mainColor,
    thickness: 1,
    text: {
      size: 0.05,
      sprite: !orderDialogOpened,
      color: mainColor,
      position: orderDialogOpened
        ? [width / 2 + 0.2, height / 2, depth / 2]
        : [width / 2 + 0.15, height / 2, depth / 2],
      rotation: [angle, Math.PI, Math.PI / 2],
    },
    endLines: {
      direction: [1, 0, 0],
    },
    length: length,
    formatter: (x) => formatter.format(1000 * x),
  }
  return (
    <>
      <Ruler {...horizontal} />
      <Ruler {...diagonal} />
    </>
  )
}
